import {METERS_PER_KM2} from '@app/util/conversions.js';

export const getMinimumSQMCost = product => {
  if (!product.area || product.area?.op !== 'gte') {
    return 0;
  }

  if (product.area.units === 'sqkm') {
    return product.area.value * METERS_PER_KM2;
  }

  if (product.area.units === 'sqm') {
    return product.area.value;
  }

  return 0;
};

export const getReservationsMessage = ({
  maxReservationsLimit,
  reservationsRemaining,
  selectedFeaturesCount,
}) => {
  const hasLimit = maxReservationsLimit > 0;

  if (!hasLimit || isNaN(reservationsRemaining)) {
    return {
      overReservationsLimit: false,
      showMessage: false,
    };
  }

  // ----------------------------------
  // Calculations

  const overReservationsLimit =
    reservationsRemaining === 0 ||
    reservationsRemaining - selectedFeaturesCount < 0;

  const numberToDeselect = selectedFeaturesCount - reservationsRemaining;

  // ----------------------------------
  // Copy

  let message = `${Math.max(reservationsRemaining, 0)} of ${maxReservationsLimit} total reservations left. ${selectedFeaturesCount} feature${selectedFeaturesCount !== 1 ? 's' : ''} selected.`;

  if (reservationsRemaining <= 0) {
    // All the reservations are already made
    message =
      'You don’t have any reservations left. Please release other features to be able to add others.';
  } else if (overReservationsLimit) {
    // The user's selection has put them over the limit
    message += ` Please deselect ${numberToDeselect} feature${numberToDeselect !== 1 ? 's' : ''} to be able to reserve.`;
  }

  return {
    message: hasLimit ? message : '',
    overReservationsLimit,
    showMessage: hasLimit,
  };
};
